import { apiCall } from '../../context/api';

export const initialize = async (baseURL, stripe, token, plan) => {
  const data = await apiCall(baseURL, token, 'POST', `/core/webhooks/stripe/create-checkout-session/${plan}`, {
    plan
  });

  const checkout = await stripe.initEmbeddedCheckout({
    clientSecret: data.clientSecret
  });

  checkout.mount('#checkout');
};
